import React from "react";
import { MusicHallBookingDetailContainerStyled } from "./styled";
import { connect } from "react-redux";
import { withRouter } from "navigations/withRouter";
import { Displays, Forms } from "components";
import { portalService } from "apiServices";
import { toast } from "react-toastify";
import { ROUTE_PATH } from "utils/constants/routePath";

class MusicHallBookingDetailContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    let resArr = await Promise.all([
      portalService.GET_ROOM_LIST(`?pagination=false`),
      portalService.GET_EQUIPMENT_LIST(`?pagination=false`),
    ]);
    if (resArr) {
      this.setState({
        musicHallRoomList: resArr[0].data.docs
          .filter((item) => item.type === "1")
          .map((e) => ({ label: e.name_th, value: e._id })),
        practiceRoomList: resArr[0].data.docs
          .filter((item) => item.type === "2")
          .map((e) => ({ label: e.name_th, value: e._id })),
        equipmentProviderList: resArr[1].data.docs
          .filter((e) => e.default_price === 0)
          .map((f) => ({ ...f, label: f.name_th, value: f._id })),
        equipmentAdditionalList: resArr[1].data.docs
          .filter((e) => e.default_price > 0)
          .map((f) => ({ ...f, label: f.name_th, value: f._id })),
        isLoading: false,
      });
    }
  };

  handleSubmit = async (values) => {
    this.setState({ isBgLoading: true });
    let params = {
      ...values,
    };
    if (values.room_type === "1") {
      params.additional_equipment = [];
      if (values.additional_equipment_additional.length > 0) {
        values.additional_equipment_additional.forEach((e) => {
          params.additional_equipment.push({
            equipment_ref_id: e._id,
            equipment_name_en: e.name_en,
            equipment_name_th: e.name_th,
            quantity_used: 1,
            price_unit: e.default_price_unit, // "per_hour", "per_piece", etc.
            subtotal: e.default_price,
          });
        });
      }
      if (values.additional_equipment_provider.length > 0) {
        values.additional_equipment_provider.forEach((e) => {
          params.additional_equipment.push({
            equipment_ref_id: e._id,
            equipment_name_en: e.name_en,
            equipment_name_th: e.name_th,
            quantity_used: 1,
            price_unit: e.default_price_unit, // "per_hour", "per_piece", etc.
            subtotal: 0,
          });
        });
      }
    }
    let res = await portalService.POST_ROOM_BOOKING_CREATE(params);
    if (res && res.status === 200) {
      this.setState({ isBgLoading: false });
      toast.success("Booking created successfully");
      this.props.router.navigate(ROUTE_PATH.MUSIC_HALL_BOOKING_LIST);
    } else {
      this.setState({ isBgLoading: false });
      toast.error("Failed to create booking");
    }
  };

  handleCancel = () => {
    this.props.router.navigate(ROUTE_PATH.MUSIC_HALL_BOOKING_LIST);
  };

  render() {
    const { authenRedux } = this.props;
    const {
      isBgLoading,
      isLoading,
      equipmentAdditionalList,
      equipmentProviderList,
      musicHallRoomList,
      practiceRoomList,
    } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find(
          (e) => e.menu_key === "music-hall-booking"
        );
    return (
      <MusicHallBookingDetailContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {isLoading ? (
          <Displays.Loading theme_standard_loading />
        ) : (
          <Forms.MusicHallBookingForm
            permission={permission}
            equipmentAdditionalList={equipmentAdditionalList}
            equipmentProviderList={equipmentProviderList}
            musicHallRoomList={musicHallRoomList}
            practiceRoomList={practiceRoomList}
            onCancel={this.handleCancel}
            onSubmit={this.handleSubmit}
          />
        )}
      </MusicHallBookingDetailContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MusicHallBookingDetailContainer));
